import {useState} from 'react';

export type ValidationError = {
  field: string;
  message: string;
};

export const useError = () => {
  const [validationError, setValidationError] = useState<ValidationError>();

  const errorMessage = (field: string) =>
    validationError?.field === field ? validationError.message : undefined;

  return {
    setValidationError,
    errorMessage,
  };
};
